(function (Drupal, $, drupalSettings, once) {
  Drupal.behaviors.film_page_header = {
    attach: function attach(context) {
      const film_page_header = once(
        'film_page_header',
        '[data-component-id="nuplayer:film_page_header"]',
        context
      );

      if (film_page_header.length > 0) {
        const filmId = drupalSettings.entityID;
        const film_guidance_overlay = '[data-component-id="nuplayer:film_guidance_overlay"]';
        const film_page_media_player = '[data-component-id="nuplayer:film_page_media_player"]';
        const $film_page_button_group = $('[data-component-id="nuplayer:film_page_button_group"]');

        // Get the latest film page header content via AJAX.
        const filmUtility = Drupal.behaviors.nuplayer.FilmUtility;
        filmUtility
          .fetchFilmHeaderContent(filmId)
          .then((headerData) => {
            // Hydrates content
            if (headerData && headerData[filmId]) {
              const filmHeaderContent = headerData[filmId];
              const colourMap = new Map();
              colourMap.set('free', 'green');
              colourMap.set('rentals', 'red');
              colourMap.set('subscription', 'purple');
              const accentColour = colourMap.get(filmHeaderContent.pillar);
              let display_subscribe_cta = false;

              // Button visibility
              for (const button of filmHeaderContent.buttons_to_display) {
                if (button === 'subscribe') {
                  display_subscribe_cta = true;
                } else {
                  $film_page_button_group.children('.' + button).removeClass('d-n');
                }
              }

              // Show subscribe CTA
              if (display_subscribe_cta) {
                $(film_page_header).find('.subscribe-cta').removeClass('d-n');
              } else {
                // CTA text
                $film_page_button_group
                  .children('.cta-button')
                  .children('h4')
                  .text(filmHeaderContent.cta_text);

                // Play button colour
                $film_page_button_group.children('.cta-button.play').addClass(accentColour);

                // Entitlement message
                const entitlement_message = filmHeaderContent.entitlement_message ?? '';
                if (entitlement_message !== '') {
                  $(film_page_header)
                    .find('.entitlement-message')
                    .text(entitlement_message)
                    .removeClass('d-n');
                }
              }

              // Hide skeleton and show content
              $(film_page_header).find('.skeleton-content').addClass('d-n');
              $(film_page_header).find('.inner-header-container').removeClass('d-n');

              // Add accent colour class to header to inform player styling
              $(film_page_media_player).addClass(accentColour + '-accent');

              // Update film card prices if the user is a member
              if (filmHeaderContent.user_has_membership) {
                $(document).trigger('carousel_block:update_prices');
              }
            } else {
              throw new Error('header content was not returned for this film id');
            }
          })
          .catch((error) => {
            console.error('Error fetching film page header content,', error);
            // Hide skeleton and show content
            $(film_page_header).find('.skeleton-content').addClass('d-n');
            $(film_page_header).find('.inner-header-container').removeClass('d-n');
          });

        $(film_page_header).on('film_page_header:scroll_into_view', function () {
          $('html, body').animate(
            {
              scrollTop: $(film_page_header).offset().top,
            },
            300
          );
        });

        $(film_page_header).on('click', '.button-group .js__play', function (event) {
          event.preventDefault();
          // Show the certification and/or viewing notice
          if (
            $('.player-overlay--certification').length > 0 ||
            $('.player-overlay--viewing-notice').length > 0
          ) {
            $(film_guidance_overlay).trigger('film_guidance_overlay:show');
          } else {
            $(film_page_media_player).trigger('film_page_media_player:play_film');
            $(film_page_header).trigger('film_page_header:scroll_into_view');
          }
        });

        $(film_page_header).on('click', '.button-group .js__trailer', function (event) {
          event.preventDefault();
          $(film_page_media_player).trigger('film_page_media_player:play_trailer');
          $(film_page_header).trigger('film_page_header:scroll_into_view');
        });

        $(film_page_header).on('click', '.button-group .js__kermode', function (event) {
          event.preventDefault();
          $(film_page_media_player).trigger('film_page_media_player:play_kermode');
          $(film_page_header).trigger('film_page_header:scroll_into_view');
        });

        $(film_page_header).on('click', '.button-group .js__intro', function (event) {
          event.preventDefault();
          $(film_page_media_player).trigger('film_page_media_player:play_intro');
          $(film_page_header).trigger('film_page_header:scroll_into_view');
        });
      }
    },
    updateEntitlementMessage: function (message) {
      const $entitlementMessage = $('[data-component-id="nuplayer:film_page_header"]').find(
        '.entitlement-message'
      );

      if ($entitlementMessage.length > 0) {
        $entitlementMessage.text(message).removeClass('d-n');
      }
    },
  };
})(Drupal, jQuery, drupalSettings, once);
